module.exports = __webpack_public_path__ + "static/img/02.2b923cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/02.jpg
// module id = D0sp
// module chunks = 1